// extracted by mini-css-extract-plugin
export default {"section-container":"BarGraphSection_section-container__pHnk8"};